var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-icon',_vm._b({attrs:{"icon":_vm.$attrs.icon || _vm.ICON.SOCIAL_SQUARE_LEARN_TERM,"title":_vm.title,"disabled":_vm.isIconDisabled,"original":true,"to":_vm.generateTermRoute(_vm.term)}},'a-icon',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }